<template>
    <div>
        <div v-if="loading" class="lds-ripple"><div></div><div></div></div>
  <div ref="pages" id="app" class="uk-background-primary uk-light">
  
   <NavBar :login="loggedIn" @logout="logout" :user="user" v-on:childToParent="searchme"></NavBar>

   <div v-if="loggedIn"> 
   <div v-if="this.modulesearch.length == 0 && searching" class="uk-margin-medium-top uk-container uk-text-center">
     <p class="uk-heading-large uk-margin-remove-bottom tm-overtitle uk-margin-top uk-text-uppercase letter-spacing-l">Aucun résultat ne correspond à votre recherche !</p>
   </div>

    <div v-if="searching">
        <div class="uk-margin-medium-top uk-margin-medium-bottom">
            <div class="uk-container uk-text-center">
                <div class="uk-grid-medium uk-child-width-1-5@m uk-grid-small uk-grid-match tm-margin-large-top uk-text-center" data-uk-grid>
                    <div v-for="onex in modulesearch" :key="onex.id">
                        <a :href="onex.url" class="uk-card uk-card-box uk-card-body uk-border-rounded">
                            <span class="uk-icon-forder uk-border-rounded"><span :data-uk-icon="'icon: ' + onex.icon+ '; ratio: 2'"></span></span>
                            <p>{{onex.title}}</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
   </div>


   <div v-if="!searching">
    <section class="uk-margin-medium-top">
        <div class="uk-container uk-text-center">
            <div v-if="permissions.rise != undefined" class="animated flipInX uk-grid-medium uk-child-width-1-1@m uk-grid-small uk-grid-match  uk-text-center" data-uk-grid>
                <div>
                    <a @click="show.rise = !show.rise" class="uk-card uk-card-box uk-card-body uk-border-rounded">
                        <span class="uk-icon-forder uk-border-rounded"><span data-uk-icon="icon: database; ratio: 2"></span></span>
                        <p>Projets</p>
                    </a>
                </div>
            </div>
            <template v-if="permissions.rise != undefined" >
               <Animated enter="zoomIn" leave="zoomOut" duration="600">
                   <Rise v-if="show.rise && permissions.rise != undefined" :permissions="permissions.rise" :modules="getDataModules(1)"></Rise>
                </Animated>
            </template>
            <div v-if="permissions.stock_manager != undefined" class="animated flipInX delay-demi uk-grid-medium uk-child-width-1-1@m uk-grid-small uk-grid-match tm-margin-large-top uk-text-center" data-uk-grid>
                <div>
                    <a @click="show.stock = !show.stock" class="uk-card uk-card-box uk-card-body uk-border-rounded">
                        <span class="uk-icon-forder uk-border-rounded"><span data-uk-icon="icon: album; ratio: 2"></span></span>
                        <p>Administration</p>
                    </a>
                </div>
            </div>
            <template v-if="permissions.stock_manager != undefined">
                <Animated  enter="zoomIn" leave="zoomOut" duration="600">
                <Stock :permissions="permissions.stock_manager" v-if="show.stock && permissions.stock_manager != undefined" :persmission="permissions.stock" :modules="getDataModules(2)"></Stock>
                </Animated>
            </template>
            <div v-if="permissions.money_manager != undefined" class="animated flipInX delay-1s uk-grid-medium uk-child-width-1-1@m uk-grid-small uk-grid-match tm-margin-large-top uk-text-center" data-uk-grid>
                <div>
                    <a @click="show.money = !show.money" class="uk-card uk-card-box uk-card-body uk-border-rounded">
                        <span class="uk-icon-forder uk-border-rounded"><span data-uk-icon="icon: cart; ratio: 2"></span></span>
                        <p>Finance</p>
                    </a>
                </div>
            </div>
            <!-- Here Money -->
            <Animated v-if="permissions.money_manager != undefined" enter="zoomIn" leave="zoomOut" duration="600">
            <Money :permissions="permissions.money_manager" v-if="show.money && permissions.money_manager != undefined" :modules="getDataModules(3)"></Money>
            </Animated>
        </div>
    </section>
    </div>

    </div>
    <div v-else>  
        <Login @submitted="submitForm"></Login>    
    </div>
    
   <div class="uk-margin-large-top uk-section-primary">  
   </div>
  
   <Footer></Footer>
     
   <div id="search" class="uk-flex-top uk-background-primary uk-modal-search" data-uk-modal>
     <button class="uk-modal-close-full uk-close-large" type="button" data-uk-close></button>
   </div>
   
   <div id="offcanvas" data-uk-offcanvas="flip: true; overlay: true">
    <div class="uk-offcanvas-bar">

        <button class="uk-offcanvas-close" type="button" data-uk-close></button>

        <ul class="uk-nav uk-nav-default">
            <li class="uk-nav-header uk-logo">Minimal</li>
            <li class="uk-parent">
                <a href="index.html">Support</a>
                <ul class="uk-nav-sub">
                    <li><a href="green.html">Green</a></li>
                    <li><a href="purple.html">Purple</a></li>
                    <li><a href="red.html">Red</a></li>
                    <li><a href="brown.html">Brown</a></li>
                </ul>
            </li>
            <li ><a href="faq.html">Faq</a></li>
            <li ><a href="changelog.html">Changelog</a></li>
            <li ><a href="download.html">Download</a></li>
            <li ><a href="contact.html">Contact</a></li>
        </ul>

    </div>
   </div>
  </div>
  </div>
</template>

<script>
import ENV from './config.js'
import NavBar from './components/NavBar.vue'
import Rise from './components/Rise.vue'
import Money from './components/Money.vue'
import Stock from './components/Stock.vue'
import Footer from './components/Footer.vue'
import Login from './components/Login.vue'
import {declareCookie} from './helper/cookie'
import {deleteAllCookies} from './helper/cookie'
import axios from 'axios'




export default {
    
  name: 'app',
  components: {
    NavBar,
    Rise,
    Money,
    Stock,
    Footer,
    Login
  },
  mounted(){
    if (this.$store.getters.connected == true){
        this.user = this.$store.getters.user;
        this.permissions = this.$store.getters.permissions;
        this.loggedIn = true;
    }
  },
  data:function(){
         let site_rise  = ENV.rise;
         let site_stock = ENV.stock;
         let site_money = ENV.money;
         let k_webservice = ENV.kwebservice;
    return{
        url:{
            rise:site_rise,
            stock:site_stock,
            money:site_money,
            kwebservice:k_webservice
        },
        show:{
              rise:false,
              money:false,
              stock:false,
        },
        modulesearch:[],
        modulesall:[
             /**--------------------------------------------------------------------------------------------------------------------------------------------------------------/**/             
             /**/  {title:'Post en ligne',/**/ role:'user',  /**/ slug:'timeline',         /**/ url:site_rise+'dashboard',         /**/ icon:'list',    /**/ type:1},         /**/
             /**/  {title:'Surveillance', /**/ role:'admin', /**/ slug:'surveillance',     /**/ url:site_rise+'surveillance/lives',/**/ icon:'list',    /**/ type:1},         /**/
             /**/  {title:'Calendrier',   /**/ role:'user',  /**/ slug:'calendar',         /**/ url:site_rise+'calendars',         /**/ icon:'calendar',/**/ type:1},         /**/
             /**/  {title:'Messages',     /**/ role:'user',  /**/ slug:'message',          /**/ url:site_rise+'messages',          /**/ icon:'mail',    /**/ type:1},         /**/
             /**/  {title:'Notes',        /**/ role:'user',  /**/ slug:'note',             /**/ url:site_rise+'notes/mynotes',     /**/ icon:'pencil',  /**/ type:1},         /**/
             /**/  {title:'Evenement',    /**/ role:'user',  /**/ slug:'event',            /**/ url:site_rise+'events',            /**/ icon:'future',  /**/ type:1},         /**/
             /**/  {title:'Reunion',      /**/ role:'user',  /**/ slug:'event',            /**/ url:site_rise+'meetings',          /**/ icon:'clock',   /**/ type:1},         /**/
             /**/  {title:'Projets',      /**/ role:'user',  /**/ slug:'project_timesheet',/**/ url:site_rise+'projects',          /**/ icon:'album',   /**/ type:1},         /**/
             /**/  {title:'Fichiers',     /**/ role:'user',  /**/ slug:'files',            /**/ url:site_rise+'files',             /**/ icon:'image',   /**/ type:1},         /**/
             /**--------------------------------------------------------------------------------------------------------------------------------------------------------------/**/
             /**/  {title:'Tableau de bord',  /**/ slug:'dashboard',     /**/ url:site_stock+'admin/',             /**/ icon:'home',         /**/ type:2},                          /**/
             /**/  {title:'Products',         /**/ slug:'products',      /**/ url:site_stock+'admin/products',     /**/ icon:'credit-card',  /**/ type:2},                          /**/
             /**/  {title:'Devis',            /**/ slug:'sales',         /**/ url:site_stock+'admin/sales',        /**/ icon:'cart',         /**/ type:2},                          /**/
             /**/  {title:'Achats',           /**/ slug:'purchases',     /**/ url:site_stock+'admin/purchases',    /**/ icon:'tag',          /**/ type:2},                          /**/
             /**/  {title:'Transferts',       /**/ slug:'transfers',     /**/ url:site_stock+'admin/transfers',    /**/ icon:'future',       /**/ type:2},                          /**/
             /**/  {title:'Bons de retours',  /**/ slug:'returns',       /**/ url:site_stock+'admin/returns',      /**/ icon:'bookmark',     /**/ type:2},                          /**/
             /**/  {title:'Utilisateurs',     /**/ slug:'users',         /**/ url:site_stock+'admin/users',        /**/ icon:'users',        /**/ type:2},                          /**/
             /**/  {title:'Notifications',    /**/ slug:'notifications', /**/ url:site_stock+'admin/notifiations', /**/ icon:'info',         /**/ type:2},                          /**/
             /**/  {title:'Calendrier',       /**/ slug:'calendar',      /**/ url:site_stock+'admin/calendar',     /**/ icon:'calendar',     /**/ type:2},                          /**/
             /**/  {title:'Paramètres',       /**/ slug:'settings',      /**/ url:site_stock+'admin/settings',     /**/ icon:'settings',     /**/ type:2},                          /**/
             /**/  {title:'Rapports',         /**/ slug:'raports',       /**/ url:site_stock+'admin/reports',      /**/ icon:'lifesaver',    /**/ type:2},                          /**/
             /**--------------------------------------------------------------------------------------------------------------------------------------------------------------/**/
             /**/  {title:'Tableau de bord',       /**/ role:'user',  /**/ slug:'dashboard',   /**/ url:site_money+'dashboard'                 /**/ ,icon:'home'        /**/ ,type:3}, /**/
             /**/  {title:'Profile',               /**/ role:'user',  /**/ slug:'profile',   /**/ url:site_money+'profile/my_profile'        /**/ ,icon:'user'        /**/ ,type:3}, /**/
             /**/  {title:'Contacts',              /**/ role:'user',  /**/ slug:'contacts',   /**/ url:site_money+'contacts'                  /**/ ,icon:'receiver'    /**/ ,type:3}, /**/
             /**/  {title:'Produits',              /**/ role:'user',  /**/ slug:'products',   /**/ url:site_money+'products'                  /**/ ,icon:'tag'         /**/ ,type:3}, /**/
             /**/  {title:'Services',              /**/ role:'user',  /**/ slug:'transfers',   /**/ url:site_money+'transfers'                 /**/ ,icon:'future'      /**/ ,type:3}, /**/
             /**/  {title:'Fournisseur',           /**/ role:'user',  /**/ slug:'suppliers',   /**/ url:site_money+'suppliers'                 /**/ ,icon:'future'      /**/ ,type:3}, /**/
             /**/  {title:'Achat',                 /**/ role:'user',  /**/ slug:'purchase_orders',   /**/ url:site_money+'purchase_orders'           /**/ ,icon:'tag'         /**/ ,type:3}, /**/
             /**/  {title:'Retour Achats',         /**/ role:'user',  /**/ slug:'purchase_returns',   /**/ url:site_money+'purchase_returns'          /**/ ,icon:'history'     /**/ ,type:3}, /**/
             /**/  {title:'Retour Ventes',         /**/ role:'user',  /**/ slug:'sales_returns',   /**/ url:site_money+'sales_returns'             /**/ ,icon:'history'     /**/ ,type:3}, /**/
             /**/  {title:'Ventes',                /**/ role:'user',  /**/ slug:'invoices',   /**/ url:site_money+'invoices'                  /**/ ,icon:'cart'        /**/ ,type:3}, /**/
             /**/  {title:'Compte bancaire',       /**/ role:'user',  /**/ slug:'accounts',   /**/ url:site_money+'accounts'                  /**/ ,icon:'credit-card' /**/ ,type:3}, /**/
             /**/  {title:'Transaction',           /**/ role:'user',  /**/ slug:'income',   /**/ url:site_money+'income'                    /**/ ,icon:'bolt'        /**/ ,type:3}, /**/
             /**/  {title:'Transaction récurrente',/**/ role:'user',  /**/ slug:'repeating_income',   /**/ url:site_money+'repeating_income'          /**/ ,icon:'bookmark'    /**/ ,type:3}, /**/
             /**/  {title:'Personnel',             /**/ role:'user',  /**/ slug:'staffs',   /**/ url:site_money+'staffs'                    /**/ ,icon:'users'       /**/ ,type:3}, /**/
             /**/  {title:'Report',                /**/ role:'user',  /**/ slug:'reports_account_statement',   /**/ url:site_money+'reports/account_statement' /**/ ,icon:'lifesaver'   /**/ ,type:3}, /**/
             /**/  {title:'Paramètres',            /**/ role:'user',  /**/ slug:'settings',   /**/ url:site_money+'company/general_settings'  /**/ ,icon:'settings'    /**/ ,type:3}, /**/
             /**--------------------------------------------------------------------------------------------------------------------------------------------------------------/**/
          ],
         
          loading:false,
          searching:false,
          loggedIn: false,
          user:{},
          permissions:[],
          cookies:null,
    }
  },
  methods:{
    getDataModules(id){
          let donner = this.modulesall.filter(info => {
              if (info.type == id) return true;
          });
           return donner
      },
    searchme(e){
          this.modulesearch = [];
          if (e == null || e == ''){
              this.searching = false; 
              return;
          }
        this.searching = true; 
        this.modulesall.forEach(mod => {
                    if (mod.title.search(new RegExp(e, "i")) < 0){
                       //
                    } else {
                    this.modulesearch.push(mod);
                }
            })
        },
    submitForm(data) {
            this.loading = true;
            this.$refs.pages.style.opacity  = 0.2;
            axios.post(`${this.url.kwebservice}/login`, data)
                .then((response) => {
                    this.loading = false;
                    this.$refs.pages.style.opacity  = 1;
                    if (response.status === 200) {
                        if (response.data) {
                           if (response.data.success) {
                               
                                this.user = response.data.kuser,
                                this.permissions = response.data.permissions;
                                this.loggedIn = true
                                this.$store.commit('logged',{user:this.user,permissions:this.permissions});
                                if (response.data.cookies) {
                                    this.cookies = response.data.cookies
                                    response.data.cookies.forEach(cookie => {
                                       declareCookie(cookie);
                                    })
                                }
                                return 
                           }
                        }
                        this.$swal({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Il semble que vous ayez saisi un nom d’utilisateur ou une adresse e-mail mal orthographiée.',
                          footer: '<a href>Why do I have this issue?</a>'
                        })
                       
                        // TODO: display error message
                    }
                })
      },
      logout(){
          this.$store.commit('logout');
          this.loggedIn = false;
          this.permissions = [];
          this.user = {},
          this.cookies = null;
          deleteAllCookies();
      }
      },
  }
</script>

<style>
.lds-ripple {
    position: fixed;
    z-index: 10;
    top: 50%;
    left: 50%;
  display: inline-block;
  width: 64px;
  height: 64px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 28px;
    left: 28px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: -1px;
    left: -1px;
    width: 58px;
    height: 58px;
    opacity: 0;
  }
}


</style>
